<template>
  <div class="animated fadeIn">

    <b-card>
      <h2>Publisher Settings</h2>
      <div class="lead">Configure your publisher accounts and authorize us to publish listings on your behalf</div>
    </b-card>

    <b-row class="mt-2">
      <b-col :md="6" class="d-flex min-300">
        <kijiji />
      </b-col>
      <b-col :md="6" class="d-flex min-300">
        <craigslist />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Kijiji from './publishers/Kijiji'
import Craigslist from './publishers/Craigslist'

export default {
  name: 'Publishers',

  components: {
    Kijiji,
    Craigslist
  }
};
</script>

<style lang="scss" scoped>
.min-300 {
  min-height: 300px;
}
</style>
